import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Constant, { getCurrency } from '../../Constant.js'
import axios from 'axios'
import Swal from 'sweetalert2'
import CheckPermission from '../../common/Permissions/CheckPermission.js'
import Button from '../../common/CustomComponents/Button.js'
class ChaletDetails extends Component {
  state = {
    chaletData: [],
    isLoading: false,
  }

  myStyle = {
    fontWeight: 'bold',
  }

  StyleForDetail = {
    marginBottom: '6px',
    letterSpacing: '0.5px',
    display: 'inline-block',
  }

  componentDidMount() {
    this.getChaletData()

    let country = localStorage.getItem('countryShortName')

    this.setState({ currency: getCurrency(country) })
  }

  getChaletData = async () => {
    var that = this
    var chaletId = this.props.match?.params?.id
    that.setState({ isLoading: true })
    await axios
      .get(Constant.getAPI() + `/chalet/get-chalet-details/${chaletId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data?.success) {
          that.setState({
            chaletData: res?.data?.data,
          })
          that.setState({ isLoading: false })
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  deleteItem = (id) => {
    Swal.fire({
      title: 'Delete',
      text: 'Are you sure?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `No`,
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(Constant.getAPI() + `/chalet/delete-chalet/${id}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
              country_short_name: `${localStorage.getItem('countryShortName')}`,
            },
          })
          .then(() => {
            window.location.href = '#/chalet-master'
            window.location.reload()
          })
          .catch((err) => {
            if (err?.response?.status === 401) {
              Constant.getAuthLogout()
            } else {
              Swal.fire({
                title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
                icon: 'error',
                text: '',
                type: 'error',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
              })
            }
          })
      }
    })
  }

  render() {
    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Chalet Details</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to={`/chalet-master`}>
                          <i className="feather">Chalet Lists</i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Chalet Details</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div
                        className="row"
                        style={{ padding: '0 10px 15px 10px', borderBottom: '1px solid #ddd' }}
                      >
                        <Button to={`/chalet-master/add/` + this.props.match?.params?.id}>Edit</Button>
                        <Button onClick={this.deleteItem.bind(this, this.props.match?.params?.id)}>Delete</Button>
                        <Button to={`/gallary-list/chalet/${this.props.match?.params?.id}`}>Gallary</Button>
                        <Button to={`/holiday-price/${this.props.match?.params?.id}`}>Holiday Prices</Button>
                        <Button to={`/chalet-package/${this.props.match?.params?.id}`}>Packages</Button>
                        <Button to={`/chalet-slot/${this.props.match?.params?.id}`}>Slots</Button>
                        <Button to={`/chalet-diwaniya/${this.props.match?.params?.id}`}>Addons</Button>
                        <CheckPermission permission={'contract-files'}>
                          <Button to={`/contract-files/chalet/${this.props.match?.params?.id}`}>Contract Files</Button>
                        </CheckPermission>
                      </div>
                      <div
                        className="row"
                        style={{ padding: 10, borderBottom: '1px solid #ddd' }}
                      >
                        <div
                          className="col-md-6 col-sm-12"
                          style={{ borderRight: '1px solid #ddd' }}
                        >
                          <div className="row">
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Chalet Details</div>
                            </div>
                            <div
                              className="col-4"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>ID</div>
                            </div>
                            <div className="col-5">
                              <div style={{ color: 'red', fontWeight: 'bold' }}>
                                {this.state.chaletData?.id || '--'}
                              </div>
                            </div>
                          </div>
                          <div
                            className="row"
                            style={{ marginBottom: 10 }}
                          >
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div></div>
                            </div>
                            <div
                              className="col-4"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Name: English</div>
                              <div>Name: Arabic</div>
                              <div>Coordinator Number</div>
                              <div>Pax. Capacity</div>
                              {/* <div>Livingrooms</div> */}
                              <div>Minimum Price</div>
                              <div>Bedrooms</div>
                              <div>Bathrooms</div>
                              <div>Lounges</div>
                              <div style={{ height: 50 }}>Image Url</div>
                              <div>Latitude</div>
                              <div>Longitude</div>
                              <div>Address : English</div>
                              <div>Address : Arabic</div>
                              <div>Address Details: English</div>
                              <div>Address Details: Arabic</div>
                            </div>
                            <div className="col-5">
                              <div>{this.state.chaletData?.name_en || '--'}</div>
                              <div>{this.state.chaletData?.name_ar || '--'}</div>
                              <div>{this.state.chaletData?.phone || '--'}</div>
                              <div>{this.state.chaletData?.max_guests || '--'}</div>
                              {/* <div>{this.state.chaletData?.livingrooms || '--'}</div> */}
                              <div>{this.state.chaletData?.minimum_price || '--'}</div>
                              <div>{this.state.chaletData?.bedrooms || '--'}</div>
                              <div>{this.state.chaletData?.bathrooms || '--'}</div>
                              <div>{this.state.chaletData?.lounges || '--'}</div>
                              <div style={{ height: 50 }}>
                                <img
                                  src={
                                    this.state.chaletData?.img && typeof this.state.chaletData?.img == 'string'
                                      ? Constant.getImage() + this.state.chaletData?.img
                                      : './assets/images/no_image.png'
                                  }
                                  className="img-fluid"
                                  alt="img"
                                  onError={(event) => {
                                    event.currentTarget.src = './assets/images/no_image.png'
                                  }}
                                  style={{ height: 40, border: '1px solid #aaa', borderRadius: 5 }}
                                />
                              </div>
                              <div>{this.state.chaletData?.lat || '--'}</div>
                              <div>{this.state.chaletData?.long || '--'}</div>
                              <div>{this.state.chaletData?.address_en || '--'}</div>
                              <div>{this.state.chaletData?.address_ar || '--'}</div>
                              <div>{this.state.chaletData?.address_details_en || '--'}</div>
                              <div>{this.state.chaletData?.address_details_ar || '--'}</div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-sm-12">
                          <div
                            className="row"
                            style={{ marginBottom: 10 }}
                          >
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Day wise Price</div>
                            </div>
                            <div
                              className="col-4"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Sunday Price</div>
                              <div>Monday Price</div>
                              <div>Tuesday Price</div>
                              <div>Wednsday Price</div>
                              <div>Thursday Price</div>
                              <div>Friday Price</div>
                              <div>Saturday Price</div>
                            </div>
                            <div className="col-5">
                              <div>
                                {this.state.chaletData?.sunday_price || '--'} {this.state.currency}
                              </div>
                              <div>
                                {this.state.chaletData?.monday_price || '--'} {this.state.currency}
                              </div>
                              <div>
                                {this.state.chaletData?.tuesday_price || '--'} {this.state.currency}
                              </div>
                              <div>
                                {this.state.chaletData?.wednesday_price || '--'} {this.state.currency}
                              </div>
                              <div>
                                {this.state.chaletData?.thursday_price || '--'} {this.state.currency}
                              </div>
                              <div>
                                {this.state.chaletData?.friday_price || '--'} {this.state.currency}
                              </div>
                              <div>
                                {this.state.chaletData?.saturday_price || '--'} {this.state.currency}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="row"
                        style={{ padding: 10, borderBottom: '1px solid #ddd' }}
                      >
                        <div
                          className="col-md-6 col-sm-12"
                          style={{ borderRight: '1px solid #ddd' }}
                        >
                          <div
                            className="row"
                            style={{ marginBottom: 10 }}
                          >
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Description: English</div>
                            </div>
                            <div className="col-9">
                              <div dangerouslySetInnerHTML={{ __html: this.state.chaletData?.desc_en }}></div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-sm-12">
                          <div
                            className="row"
                            style={{ marginBottom: 10 }}
                          >
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Description: Arabic</div>
                            </div>
                            <div className="col-9">
                              <div dangerouslySetInnerHTML={{ __html: this.state.chaletData?.desc_ar }}></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="row"
                        style={{ padding: 10, borderBottom: '1px solid #ddd' }}
                      >
                        <div
                          className="col-md-6 col-sm-12"
                          style={{ borderRight: '1px solid #ddd' }}
                        >
                          <div
                            className="row"
                            style={{ marginBottom: 10 }}
                          >
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Refund Policy: English</div>
                            </div>
                            <div className="col-9">
                              <div dangerouslySetInnerHTML={{ __html: this.state.chaletData?.refund_policy_en }}></div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-sm-12">
                          <div
                            className="row"
                            style={{ marginBottom: 10 }}
                          >
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Refund Policy: Arabic</div>
                            </div>
                            <div className="col-9">
                              <div dangerouslySetInnerHTML={{ __html: this.state.chaletData?.refund_policy_ar }}></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="row"
                        style={{ padding: 10, borderBottom: '1px solid #ddd' }}
                      >
                        <div
                          className="col-md-6 col-sm-12"
                          style={{ borderRight: '1px solid #ddd' }}
                        >
                          <div
                            className="row"
                            style={{ marginBottom: 10 }}
                          >
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Chalet Policy: English</div>
                            </div>
                            <div className="col-9">
                              <div dangerouslySetInnerHTML={{ __html: this.state.chaletData?.policy_en }}></div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-sm-12">
                          <div
                            className="row"
                            style={{ marginBottom: 10 }}
                          >
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Chalet Policy: Arabic</div>
                            </div>
                            <div className="col-9">
                              <div dangerouslySetInnerHTML={{ __html: this.state.chaletData?.policy_ar }}></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ChaletDetails
